import type {
	AddPaymentInfoEcommerce,
	AddShippingInfoEcommerce,
	BeginCheckoutEcommerce,
	GTMProduct,
	PageView,
	PurchaseEcommerce,
	ViewCartEcommerce,
	ViewItemListEcommerce,
} from "~/lib/gtm/types";
import { sendGTMEvent } from "~/lib/gtm/utils";

export const gtm = {
	pageView: (data: PageView) => {
		sendGTMEvent(data);
	},
	addToCart: (item: GTMProduct) => {
		sendGTMEvent({
			event: "add_to_cart",
			ecommerce: {
				items: [item],
				currency: item.currency,
				value: item.price,
			},
		});
	},
	removeFromCart: (item: GTMProduct) => {
		sendGTMEvent({
			event: "remove_from_cart",
			ecommerce: {
				items: [item],
				currency: item.currency,
				value: item.price,
			},
		});
	},
	subscribe: () => {
		sendGTMEvent({
			event: "newsletter",
		});
	},
	viewItem: (item: GTMProduct) => {
		sendGTMEvent({
			event: "view_item",
			ecommerce: {
				items: [item],
				currency: item.currency,
				value: item.price,
			},
		});
	},
	viewItemList: (ecommerce: ViewItemListEcommerce) => {
		sendGTMEvent({
			event: "view_item_list",
			ecommerce,
		});
	},
	viewCart: (ecommerce: ViewCartEcommerce) => {
		sendGTMEvent({
			event: "view_cart",
			ecommerce,
		});
	},
	beginCheckout: (ecommerce: BeginCheckoutEcommerce) => {
		sendGTMEvent({
			event: "begin_checkout",
			ecommerce,
		});
	},
	addPaymentInfo: (ecommerce: AddPaymentInfoEcommerce) => {
		sendGTMEvent({
			event: "add_payment_info",
			ecommerce,
		});
	},
	addShippingMethod: (ecommerce: AddShippingInfoEcommerce) => {
		sendGTMEvent({
			event: "add_shipping_info",
			ecommerce,
		});
	},
	purchase: (ecommerce: PurchaseEcommerce) => {
		sendGTMEvent({
			event: "purchase",
			ecommerce,
		});
	},
};
